// extracted by mini-css-extract-plugin
module.exports = {"Container":"ErrorPage_Container__QPAaP","Title":"ErrorPage_Title__1GRbt","Subtitle":"ErrorPage_Subtitle__3261k","Email":"ErrorPage_Email__1GYTk","Button":"ErrorPage_Button__gOFW7"};